import {
  ActionsPage
  AppView
  DisabledRelations
  DisabledTypes
  GraphColors
  Macro
  MemberKeys
  NameKeys
  Namespaces
  RelationLabels
  SpreadSheetView
  TypeColors
  TypeSizes
} from '../'
import ConfigQuery from '../ConfigQuery'
import { branch, namespaces } from '../constants'

classes = {
  ActionsPage
  AppView
  DisabledRelations
  DisabledTypes
  GraphColors
  Macro
  MemberKeys
  NameKeys
  Namespaces
  RelationLabels
  SpreadSheetView
  TypeColors
  TypeSizes
}

DISABLED_RELATIONS = 'disabledRelations'
DISABLED_TYPES = 'disabledTypes'
MEMBER_KEYS = 'memberKeys'
NAME_KEYS = 'nameKeys'
NAMESPACES = 'namespaces'
TYPECOLORS = 'typeColors'
TYPESIZES = 'typeSizes'
GRAPHCOLORS = 'graphColors'
RELATION_LABELS = 'relationLabels'

module.exports = (transaction) ->
  await Weaver.Node.batchSave(
    _.map(classes, ({ className }) ->
      new Weaver.Node(className).set('name', className)
    )
  , { transaction, branch, commitMessage: "Instantiate config classes." })

  await new MemberKeys().update(['type'], { transaction })
  await new NameKeys().update(['name'], { transaction })
  await new Namespaces()
    .set('enabled', true)
    .updateMap(namespaces, { transaction })
  await new DisabledRelations().update([], { transaction })
  await new DisabledTypes().update([], { transaction })
  await new TypeColors().update({ 'undefined': '#EEEEEE' }, { transaction })
  await new GraphColors().update({ 'undefined': '#EEEEEE' }, { transaction })
  await new TypeSizes().update({}, { transaction })
  await new RelationLabels().update({}, { transaction })
